import React, { useContext, useEffect, useState } from "react";
import { Button, Container, Modal, ModalBody } from "reactstrap";
import Header from "../../components/Headers/Header";
import AdminNavbar from "../../components/Navbars/AdminNavbar/AdminNavbar";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import Dashboard from "../../components/Dashboard/Dashboard";
import { useLocation, useParams } from "react-router-dom";
import { DocumentTypeContext } from "../../context/DocumentContext";
import ModalComponent from "../../components/ModalComponent/ModalComponent";
import { BigButton } from "../../components/PdfEditor/BigButton";
import { getQueryParam } from "../../utils/getQueryOaram";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import "./SignDocument.css";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import { UserTypeContext } from "../../context/UserTypeContext";
import { AuthContext } from "../../context/AuthContext";
import api from "../../api";
import { UserToken } from "../../context/hooks/useAuth";
import { jwtDecode } from "jwt-decode";
import { useToast } from "../../context/ToastContext";
import { getDocumentSummaryGat } from "../../gateways/DocumentGateway";

const SignDocument = () => {
  const location = useLocation();
  const showToast = useToast();
  const { getDocumentSign, setInfoSign, getSigners, signers, infoSign } =
    useContext(DocumentTypeContext);
  const { getUsersById, getUserIp, formValuesUsers } =
    useContext(UserTypeContext);
  const { decryptToken } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [openSignersModal, setOpenSignersModal] = useState(false);
  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [summaryText, setSummaryText] = useState<string>("");
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const url = window.location.href;
  const urlObj = new URL(url);
  const isMobile = window.innerWidth <= 768;

  let objUserTk: UserToken;
  if (localStorage.getItem("token")) {
    objUserTk = jwtDecode(localStorage.getItem("token") || "");
  } else {
    objUserTk = {} as UserToken;
  }

  useEffect(() => {
    let token = urlObj.searchParams.get("token");
    const documentId = urlObj.searchParams.get("documentId");
    const toPainel = urlObj.searchParams.get("sign");
  
    token = decodeURIComponent(token || "").replace(/ /g, "+");
  
    let errorShown = false;
  
    const showSingleError = () => {
      if (!errorShown) {
        showToast("error", "Contrato expirado ou inválido. Entre em contato com o proprietário do documento.");
        errorShown = true;
      }
    };
  
    const getDocument = async () => {
      if (token) {
        setPageLoading(true);
        const result = await decryptToken(token);
  
        if (result?.data?.data) {
          const { documentId, userId } = result.data.data;
          setInfoSign(result.data.data);
  
          try {
            await Promise.all([
              getDocumentSign(documentId, true),
              getSigners(documentId, true),
              getUsersById(userId, true)
            ]);
          } catch (error) {
            showSingleError();
          }
  
          await getUserIp();
        } else {
          showSingleError();
        }
        setPageLoading(false);
      }
    };
  
    const getDocumentById = async () => {
      if (documentId) {
        setPageLoading(true);
        try {
          await Promise.all([
            getDocumentSign(documentId, true),
            getSigners(documentId, true),
            getUsersById(objUserTk.UserId, true)
          ]);
  
          if (toPainel) {
            setInfoSign({ documentId, userId: objUserTk.UserId });
            await getUserIp();
          }
        } catch (error) {
          showSingleError();
        }
        setPageLoading(false);
      }
    };
  
    if (token) {
      getDocument();
    } else if (documentId) {
      getDocumentById();
    }
  }, []);
  
  const hasSigned = signers.find(
    (x: any) => x.name === formValuesUsers.email
  )?.hasSigned;

  const resolveDocumentId = () => {
    const docIdFromUrl = urlObj.searchParams.get("documentId");
    if (docIdFromUrl) return docIdFromUrl;
    if (infoSign?.documentId) return infoSign.documentId;
    return null;
  };

  const handleOpenSummary = async () => {
    const documentId = resolveDocumentId();

    if (!documentId) {
      showToast("error", "Documento não encontrado para gerar o resumo.");
      return;
    }

    try {
      setOpenSummaryModal(true);
      setSummaryLoading(true);
      setSummaryText("");
      const output = await getDocumentSummaryGat(documentId);
      setSummaryText(output || "Nenhum resumo retornado pela IA.");
    } catch (error) {
      console.error(error);
      setSummaryText("Erro ao gerar resumo do documento.");
      showToast("error", "Erro ao gerar resumo do documento.");
    } finally {
      setSummaryLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          gap: "20px",
          backgroundColor: "#f5f5f5",
        }}
      >
        <div
          style={{
            width: 48,
            height: 48,
            border: "4px solid #e0e0e0",
            borderTop: "4px solid #F9B233",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <span style={{ color: "#666", fontSize: 15, fontWeight: 500 }}>
          Carregando documento...
        </span>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <>
      <LoadingSpinner />
      {/* Header adaptável: desktop/tablet mantém layout antigo; mobile coloca ações ao lado do botão Voltar */}
      <div
        className="header"
        style={{
          backgroundColor: "transparent",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "10px",
          boxSizing: "border-box",
          gap: 8,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {/* Voltar */}
          <Button
            onClick={() => window.history.back()}
            type="button"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: isMobile ? "6px 8px" : "8px 14px",
              minWidth: isMobile ? 40 : undefined,
              borderRadius: 999,
              fontSize: 12,
            }}
          >
            <ArrowBackIosNewIcon />
            {!isMobile && "Voltar"}
          </Button>

          {/* Ações principais – ficam ao lado do Voltar no mobile e mais à direita em telas maiores */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Button
              disabled={hasSigned}
              onClick={() => setOpen(true)}
              type="button"
              style={{
                padding: isMobile ? "6px 12px" : "8px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                backgroundColor: "#f59e0b",
                borderRadius: 999,
                border: "none",
                color: "#fff",
                boxShadow: "0 2px 5px rgba(245, 158, 11, 0.35)",
                fontSize: 13,
              }}
            >
              <CreateOutlinedIcon fontSize="small" />
              Assinar
            </Button>

            <Button
              type="button"
              onClick={handleOpenSummary}
              style={{
                backgroundColor: "#e5e7eb",
                color: "#374151",
                borderRadius: 999,
                border: "none",
                boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                padding: isMobile ? "6px 10px" : "8px 14px",
                fontSize: 12,
              }}
            >
              Resumo IA
            </Button>

            <Button
              type="button"
              onClick={() => setOpenSignersModal(true)}
              style={{
                backgroundColor: "#e5e7eb",
                color: "#374151",
                borderRadius: 999,
                border: "none",
                boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                padding: isMobile ? "6px 10px" : "8px 14px",
                fontSize: 12,
              }}
            >
              Signatários
            </Button>
          </div>
        </div>

        {!isMobile && (
          <img
            className="sign-document-logo"
            alt="Logo"
            src={require("../../assets/img/brand/logoendocpngico.png")}
          />
        )}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          gap: "20px",
          padding: "20px",
          flexWrap: "wrap",
        }}
      >
        {/* Card dos Signatários (escondido no mobile; disponível via modal) */}
        {!isMobile && (
          <div
            className="signers-panel"
            style={{
              flex: "1",
              maxWidth: "350px",
              borderRadius: "10px",
              padding: "20px",
              backgroundColor: "#fff",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              minWidth: "300px",
              marginTop: "66px",
            }}
          >
            <h3
              style={{
                textAlign: "center",
                marginBottom: "20px",
                fontSize: "18px",
                color: "#75788D",
                marginTop: "10px",
                fontWeight: "bold",
              }}
            >
              Signatários
            </h3>

            {signers?.length > 0 &&
              signers.map((signer: any, index: any) => (
                <div
                  key={index}
                  className="signer-card"
                  style={{
                    borderRadius: "10px",
                    padding: "15px",
                    backgroundColor: "#f9f9f9",
                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                    marginBottom: "10px",
                  }}
                >
                  <div className="signer-card-content">
                    <span className="signer-card-name">{signer.name}</span>
                    <span className="signer-card-email" title={signer.email}>
                      {signer.email}
                    </span>
                    <span
                      className={`signer-card-status ${signer.hasSigned ? "signed" : "pending"}`}
                    >
                      {signer.hasSigned ? "Assinado" : "Pendente"}
                    </span>
                  </div>
                </div>
              ))}
          </div>
        )}

        <div
          style={{
            flex: "2",
            width: "100%",
            maxWidth: isMobile ? "100%" : "900px",
            padding: isMobile ? "0" : "0 20px",
          }}
        >
          <Container className="mt-5">
            <Dashboard />
          </Container>
        </div>
      </div>

      <ModalComponent openModal={open} closeModal={() => setOpen(false)} />

      {/* Modal de Signatários para mobile */}
      <Modal
        isOpen={openSignersModal}
        toggle={() => setOpenSignersModal(false)}
        className="modal-content"
        style={{ maxWidth: "500px", borderRadius: "10px" }}
      >
        <div className="modal-header text-center">
          <h4 className="w-100" style={{ fontWeight: "bold", color: "#333" }}>
            Signatários
          </h4>
        </div>
        <ModalBody
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
            padding: "16px 20px",
          }}
        >
          {signers?.length > 0 ? (
            signers.map((signer: any, index: any) => (
              <div
                key={index}
                className="signer-card"
                style={{
                  borderRadius: "10px",
                  padding: "15px",
                  backgroundColor: "#f9f9f9",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <div className="signer-card-content">
                  <span className="signer-card-name">{signer.name}</span>
                  <span className="signer-card-email" title={signer.email}>
                    {signer.email}
                  </span>
                  <span
                    className={`signer-card-status ${signer.hasSigned ? "signed" : "pending"}`}
                  >
                    {signer.hasSigned ? "Assinado" : "Pendente"}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p style={{ textAlign: "center", margin: 0 }}>
              Nenhum signatário encontrado.
            </p>
          )}
        </ModalBody>
      </Modal>

      {/* Modal de Resumo IA */}
      <Modal
        isOpen={openSummaryModal}
        toggle={() => setOpenSummaryModal(false)}
        className="modal-content"
        style={{ maxWidth: "600px", borderRadius: "10px" }}
      >
        <div className="modal-header text-center">
          <h4 className="w-100" style={{ fontWeight: "bold", color: "#333" }}>
            Resumo do Documento (IA)
          </h4>
        </div>
        <ModalBody
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
            padding: "16px 20px",
            whiteSpace: "pre-wrap",
            fontSize: 14,
            lineHeight: 1.5,
          }}
        >
          {summaryLoading ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
                padding: "20px 0",
              }}
            >
              <div
                style={{
                  width: 32,
                  height: 32,
                  border: "3px solid #e0e0e0",
                  borderTop: "3px solid #F9B233",
                  borderRadius: "50%",
                  animation: "spin 0.8s linear infinite",
                }}
              />
              <span style={{ color: "#555", fontSize: 13 }}>
                Gerando resumo do documento...
              </span>
            </div>
          ) : (
            <p style={{ margin: 0 }}>{summaryText}</p>
          )}
        </ModalBody>
      </Modal>

      <style>
        {`
      @media (max-width: 768px) {
        div[style*="flex-direction: row"] {
          flex-direction: column !important;
          align-items: center !important;
        }

        div[style*="flex: 2"] {
          width: 100% !important;
          max-width: 100% !important;
        }

        div[style*="flex: 1"] {
          width: 100% !important;
          max-width: 100% !important;
        }
      }
    `}
      </style>
    </>
  );
};

export default SignDocument;
